import { render, staticRenderFns } from "./viewPost.vue?vue&type=template&id=cc4f7df6&scoped=true"
import script from "./viewPost.vue?vue&type=script&lang=js"
export * from "./viewPost.vue?vue&type=script&lang=js"
import style0 from "./viewPost.vue?vue&type=style&index=0&id=cc4f7df6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4f7df6",
  null
  
)

export default component.exports